<template>
  <div class="public-footer">
    <div class="container">
      <div class="header display-flex-between flex-align-center">
        <div class="item flex-center">
          <img src="~@assets/img/footer/footer-header-1.png">
          芝麻信用免押金租赁
        </div>
        <div class="item flex-center">
          <img src="~@assets/img/footer/footer-header-2.png">
          数百万用户信赖平台
        </div>
        <div class="item flex-center">
          <img src="~@assets/img/footer/footer-header-3.png">
          全品类新奇数码
        </div>
        <div class="item flex-center">
          <img src="~@assets/img/footer/footer-header-4.png">
          “安心享”服务无忧体验
        </div>
        <div class="item flex-center">
          <img src="~@assets/img/footer/footer-header-5.png">
          全国多地门店自提自还
        </div>
      </div>
      <div class="clearfix">
        <div class="float-left contact-wrap">
          <p class="call-wrap flex flex-align-center">
            <img src="~@assets/img/footer/footer-call.png" alt="电话">
            <span>400-008-9505</span>
          </p>
          <!-- <p>深圳市南山区高新南一道17号万德莱大厦北座306-309</p> -->
          <!-- <p>深圳市南山区粤海街道麻岭社区科研路9号比克科技大厦1801B</p> -->
          <p>广东省深圳市南山区粤海街道科技园社区科苑路15号科兴科学园 A2栋1701</p>
          <!-- <div class="service-wrap normal-btn flex-center select-point" @click="chat">
            <img src="~@assets/img/footer/footer-service.png" alt="客服">
            <span>在线客服</span>
          </div>
          <p class="font-12">（服务时间：9:00-20:00）</p> -->
          <p class="font-12">服务时间：9:00-20:00</p>
        </div>
        <div class="float-left nav-wrap">
          <p class="title">
            快捷导航
          </p>
          <ul class="nav-list">
            <li v-for="item in navData" class="vertical-middle">
              <router-link :to="item.path">{{ item.name }}</router-link>
            </li>
          </ul>
        </div>
        <div class="float-right follow-wrap">
          <div class="title display-flex-between flex-align-center">
            <span>关注我们</span>
            <div class="relative">
              <img class="wechat-btn" src="~@assets/img/footer/footer-wechat.png" alt="微信">
              <img class="wechat-code" src="~@assets/img/footer/wechat.png" alt="微信二维码">
              <img class="select-point" src="~@assets/img/footer/footer-weibo.png" alt="微博" @click="openWeibo">
            </div>
          </div>
          <div class="display-flex-between flex-align-center">
            <div class="item">
              <img class="block width-full" src="~@assets/img/code/code-alipay.png" alt="支付宝二维码">
              <p>支付宝扫码体验</p>
            </div>
            <div class="item">
              <img class="block width-full" src="~@assets/img/code/code-app.png" alt="APP二维码">
              <p>下载探物APP</p>
            </div>
          </div>
        </div>
      </div>
      <p class="copyright">Copyright © 2016 深圳探物网络科技有限公司 All Rights Reserved.<span class="hover-text" @click="openGov">粤ICP备16035270号</span> <span class="hover-text" @click="openDxzhglGov">增值电信业务经营许可证：合字B2-20260747</span></p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  data() {
    return {
      navData: [
        {
          name: '首页', path: '/home'
        },
        {
          name: '关于探物', path: '/aboutUs'
        },
        {
          name: '产品中心', path: '/rent'
        },
        {
          name: '常见问题', path: '/question'
        },
        // {
        // 	name:'新闻资讯',path:'/news'
        // },
        {
          name: '产品测评', path: '/assess'
        },
        {
          name: '隐私条款', path: '/serverTerms'
        },
        {
          name: '加入我们', path: '/joinUs'
        },
        {
          name: '商务合作', path: '/partner'
        },
        {
          name: '免责声明', path: '/disclaimer'
        },

      ]
    }
  },
  methods: {
    chat() {
      window.open('https://cschat.antcloud.com.cn/index.htm?tntInstId=WMXFZSCN&scene=SCE00001134');
    },
    openWeibo() {
      window.open('https://weibo.com/tanwuapp?topnav=1&wvr=6&topsug=1&is_all=1#_rnd1471516494575');
    },
    openGov() {
      // window.open('https://www.beian.miit.gov.cn');
      window.open('https://beian.miit.gov.cn/');
    },
    openDxzhglGov() {
      window.open('https://dxzhgl.miit.gov.cn');
    }
  }
}
</script>

<style lang="scss">
.public-footer {
  font-size: 14px;
  padding-bottom: 24px;
  background: #1D1D1D;
  color: rgba($color: #fff, $alpha: 0.8);
  letter-spacing: 1px;

  .container {
    box-sizing: border-box;
    width: 1400px;

    @media only screen and (max-width: 1400px) {
      width: 100%;
      padding: 0 40px;
    }
  }

  .header {
    margin-bottom: 47px;
    padding: 24px 0;
    text-align: center;
    border-bottom: 2px solid rgba($color: #FAFAFA, $alpha: 0.06);
    box-sizing: border-box;

    .item {
      position: relative;
      width: 20%;
      white-space: nowrap;

      &:not(:last-child)::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 0;
        width: 1px;
        height: 30px;
        margin-top: -15px;
        background: rgba($color: #FAFAFA, $alpha: 0.06);
      }

      img {
        width: 15.6%;
        min-width: 30px;
        margin-right: 10px;
      }
    }

    @media only screen and (max-width: 1200px) {
      font-size: 12px;
    }
  }

  .contact-wrap {
    width: 27.14%;
    min-width: 280px;

    .call-wrap {
      font-size: 24px;
      color: #fff;
      margin-bottom: 8px;

      img {
        width: 30px;
        margin-right: 2px;
      }
    }

    // .service-wrap{
    // 	position: relative;
    // 	margin-bottom: 12px;
    // 	margin-top: 26px;
    // 	border:1px solid rgba($color: #fff, $alpha: 0.2);
    // 	border-radius: 22px;
    // 	width: 160px;
    // 	height: 44px;
    // 	box-sizing: border-box;
    // 	color: #fff;
    // 	overflow: hidden;
    // 	&::before{
    // 		content: '';
    // 		position: absolute;
    // 		left: 0;
    // 		bottom: 0;
    // 		top: 0;
    // 		width: 100%;
    // 		background: rgba($color: #ffffff, $alpha: 0.2);
    // 		transition: transform .3s ease-in-out;
    // 		transform: scaleX(0);
    // 		transform-origin: 100% 0;
    // 	}
    // 	img{
    // 		width: 24px;
    // 		margin-right:6px;
    // 	}
    // 	&:hover::before{
    // 		transform: scaleX(1);
    // 		transform-origin: 0 0;
    // 	}
    // }
    .service-wrap {
      display: flex;
      position: relative;
      margin-bottom: 12px;
      margin-top: 26px;
      margin-left: 0;
      border-radius: 22px;
      width: 160px;
      height: 44px;
      box-sizing: border-box;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      overflow: hidden;

      img {
        width: 24px;
        margin-right: 6px;
      }
    }
  }

  .nav-wrap {
    .title {
      font-weight: bold;
      font-size: 16px;
    }

    .nav-list {
      font-size: 14px;
      margin-top: 20px;
      width: 440px;

      li {
        white-space: nowrap;
        width: 60px;
        margin-right: 84px;
        margin-bottom: 16px;
        transition: color 0.3s;

        &:hover {
          color: #3ED8C4;
        }

        @media only screen and (max-width: 1200px) {
          margin-right: 44px;
        }
      }

      @media only screen and (max-width: 1200px) {
        width: 340px;
      }
    }
  }

  .follow-wrap {
    width: 218px;

    @media only screen and (max-width: 1000px) {
      width: 200px;
    }

    .title {
      font-weight: bold;
      font-size: 16px;

      img {
        width: 30px;
        margin-left: 3px;
      }

      .wechat-code {
        display: none;
        position: absolute;
        width: 180px;
        bottom: 10px;
        right: -35px;
      }

      .wechat-btn {
        position: relative;
        z-index: 2;
        cursor: pointer;
      }

      .wechat-btn:hover+.wechat-code {
        display: block;
        animation: downAnim 0.3s;
      }
    }

    .item {
      font-size: 12px;
      text-align: center;
      width: 45.87%;
      margin-top: 9px;

      img {
        margin-bottom: 8px;
      }
    }
  }

  .copyright {
    font-size: 12px;
    color: rgba($color: #fff, $alpha: 0.4);
    text-align: center;
    margin-top: 75px;

  }

  .hover-text {
    cursor: pointer;

    &:hover {
      color: rgba($color: #fff, $alpha: 0.6);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue